import { render } from "./LoyaltyTierBenefit.vue?vue&type=template&id=7534a817&scoped=true"
import script from "./LoyaltyTierBenefit.vue?vue&type=script&lang=js"
export * from "./LoyaltyTierBenefit.vue?vue&type=script&lang=js"

import "./LoyaltyTierBenefit.vue?vue&type=style&index=0&id=7534a817&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7534a817"]])

export default __exports__